import { useEffect } from 'react';

export function useScrollLock(isLocked) {
    useEffect(() => {
        if (!isLocked) return;

        const scrollY = window.scrollY;

        const preventTouchMove = (e) => {
            e.preventDefault();
        };

        document.body.style.overflow = 'hidden';

        document.addEventListener('touchmove', preventTouchMove, { passive: false });

        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('touchmove', preventTouchMove);
            window.scrollTo({ top: scrollY, behavior: 'instant' });
        };
    }, [isLocked]);
}